import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  section: {
    marginTop: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 12
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 600,
    color: '#424242',
    marginBottom: 0
  }
})

function SlackForm ({ targetIdentifier, configuration, onChangeTargetIdentifier, onChangeConfiguration }) {
  const classes = useStyles()
  const message = configuration?.slack?.message ?? ''

  const handleChannelChange = useCallback((e) => {
    onChangeTargetIdentifier(e.target.value || null)
  }, [onChangeTargetIdentifier])

  const handleMessageChange = useCallback((e) => {
    onChangeConfiguration({
      ...configuration,
      slack: { ...(configuration?.slack ?? {}), message: e.target.value }
    })
  }, [configuration, onChangeConfiguration])

  return (
    <div className={classes.section}>
      <div className={classes.sectionTitle}>Slack Configuration</div>
      <TextField
        label='Channel ID'
        variant='outlined'
        size='small'
        value={targetIdentifier || ''}
        onChange={handleChannelChange}
        fullWidth
      />
      <TextField
        label='Message Template'
        variant='outlined'
        size='small'
        multiline
        minRows={3}
        maxRows={8}
        value={message}
        onChange={handleMessageChange}
        fullWidth
      />
    </div>
  )
}

SlackForm.propTypes = {
  targetIdentifier: PropTypes.string,
  configuration: PropTypes.object,
  onChangeTargetIdentifier: PropTypes.func.isRequired,
  onChangeConfiguration: PropTypes.func.isRequired
}

export default SlackForm
